/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'close': {
    viewBox: '5 5 22 22',
    data: `<path d="M17.4,16l7.8-7.8c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0L16,14.6L8.2,6.8c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l7.8,7.8l-7.8,7.8 c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l7.8-7.8l7.8,7.8c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L17.4,16z"/>`
  }
})
